import { render, staticRenderFns } from "./PageBarItem.vue?vue&type=template&id=4efcc0dc"
import script from "./PageBarItem.vue?vue&type=script&lang=js"
export * from "./PageBarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports